import { render, staticRenderFns } from "./Jx3Dat.vue?vue&type=template&id=38f95e96"
import script from "./Jx3Dat.vue?vue&type=script&lang=js"
export * from "./Jx3Dat.vue?vue&type=script&lang=js"
import style0 from "./Jx3Dat.vue?vue&type=style&index=0&id=38f95e96&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports